import firebase from "firebase/compat/app";
import "firebase/compat/messaging";
import store from "../../store";
import { appNotificationReceived } from "../../../src/actions";

// export const firebaseConfig = process.env.REACT_APP_FIREBASE_CONFIG;

if (process.env.REACT_APP_HEROKU_PIPELINE_ENV == "staging") {
  var firebaseConfig = {
    apiKey: "AIzaSyCWItOdh8eq8lmErrsiMmkFcoIRjj7b8wA",
    authDomain: "leadretail-qa.firebaseapp.com",
    databaseURL: "https://leadretail-qa.firebaseio.com",
    projectId: "leadretail-qa",
    storageBucket: "leadretail-qa.firebasestorage.app",
    messagingSenderId: "693631061959",
    appId: "1:693631061959:web:7a94a2b34ca1f63409d3e2",
    measurementId: "G-HLGCMT7NPN",
  };
  var vapid_key =
    "BMK-NiKj6Y2IOf_978lpH4syE8Evfqi0T9Uzj_RUzJ9DGskkE8tlQe6nDOtSJcQduHdsXjwT57tPmq9QhbD0F-c";
} else if (process.env.REACT_APP_HEROKU_PIPELINE_ENV == "preprod") {
  var firebaseConfig = {
    apiKey: "AIzaSyArY0WM5dE_Bq0zjXqnh6so6XzJ7Lgzuno",
    authDomain: "leadretail-prod.firebaseapp.com",
    databaseURL: "https://leadretail-prod.firebaseio.com",
    projectId: "leadretail-prod",
    storageBucket: "leadretail-prod.appspot.com",
    messagingSenderId: "5226404346",
    appId: "1:5226404346:web:4ad526e83df728cb69ac43",
    measurementId: "G-KD9K6YV3Q4",
  };
  var vapid_key =
    "BFVPM2WWVDrycvq6r6kFmEv_hP0AT67kCaP1FLe-TWwAc6mwnfMQxZBCg0HQ0sZbskPpLj9J3EakmATe1jSl6zo";
} else if (process.env.REACT_APP_HEROKU_PIPELINE_ENV == "prod") {
  var firebaseConfig = {
    apiKey: "AIzaSyArY0WM5dE_Bq0zjXqnh6so6XzJ7Lgzuno",
    authDomain: "leadretail-prod.firebaseapp.com",
    databaseURL: "https://leadretail-prod.firebaseio.com",
    projectId: "leadretail-prod",
    storageBucket: "leadretail-prod.appspot.com",
    messagingSenderId: "5226404346",
    appId: "1:5226404346:web:4ad526e83df728cb69ac43",
    measurementId: "G-KD9K6YV3Q4",
  };
  var vapid_key =
    "BFVPM2WWVDrycvq6r6kFmEv_hP0AT67kCaP1FLe-TWwAc6mwnfMQxZBCg0HQ0sZbskPpLj9J3EakmATe1jSl6zo";
} else {
  // default to prod
  var firebaseConfig = {
    apiKey: "AIzaSyArY0WM5dE_Bq0zjXqnh6so6XzJ7Lgzuno",
    authDomain: "leadretail-prod.firebaseapp.com",
    databaseURL: "https://leadretail-prod.firebaseio.com",
    projectId: "leadretail-prod",
    storageBucket: "leadretail-prod.appspot.com",
    messagingSenderId: "5226404346",
    appId: "1:5226404346:web:4ad526e83df728cb69ac43",
    measurementId: "G-KD9K6YV3Q4",
  };
  var vapid_key =
    "BFVPM2WWVDrycvq6r6kFmEv_hP0AT67kCaP1FLe-TWwAc6mwnfMQxZBCg0HQ0sZbskPpLj9J3EakmATe1jSl6zo";
}

// const userAgent = navigator.userAgent.toLowerCase();
// export const fcmUnsupported =
//   userAgent.indexOf("iphone") > -1 || userAgent.indexOf("mac os") > -1;

export const fcmUnsupported = !("Notification" in window);
export { vapid_key };

let messagingInst = null;

export default async function initialize() {
  console.log(
    "process.env.REACT_APP_HEROKU_PIPELINE_ENV from firebase.js: ",
    process.env.REACT_APP_HEROKU_PIPELINE_ENV
  );
  console.log("fcmUnsupported", fcmUnsupported);

  if (fcmUnsupported) return;
  // Initialize Firebase
  console.log("Initializing Firebase");
  if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
  }

  if (!messagingInst) {
    messagingInst = firebase.messaging();

    messagingInst.onMessage((payload) => {
      console.log("Message received in foreground. ", payload);
      store.dispatch(appNotificationReceived(payload.data));
    });

    // Don't automatically get token during initialization
    // Token will be requested only when user grants permission via subscribeNotifications
    console.log("Firebase messaging initialized, ready for token requests");

    // if (firebaseConfig) {
    //   // firebase.initializeApp(JSON.parse(firebaseConfig));
    //   firebase.initializeApp(firebaseConfig);
    //   // Retrieve Firebase Messaging object.
    //   const messagingInst = firebase.messaging();
    //   messagingInst.onMessage((payload) => {
    //     console.log("Message received in foreground. ", payload);
    //     store.dispatch(appNotificationReceived(payload.data));
    //   });
    //   // Add the public key generated from the console here.
    //   // messagingInst.usePublicVapidKey('BFVPM2WWVDrycvq6r6kFmEv_hP0AT67kCaP1FLe-TWwAc6mwnfMQxZBCg0HQ0sZbskPpLj9J3EakmATe1jSl6zo');
    //   messagingInst.getToken({
    //     vapidKey:
    //       "BFVPM2WWVDrycvq6r6kFmEv_hP0AT67kCaP1FLe-TWwAc6mwnfMQxZBCg0HQ0sZbskPpLj9J3EakmATe1jSl6zo",
    //   });

    //   // Tell messaging to use the existing service worker to handle messages.
    //   if ("serviceWorker" in navigator) {
    //     navigator.serviceWorker.ready.then((serviceWorkerRegistration) => {
    //       // messagingInst.useServiceWorker(serviceWorkerRegistration);
    //       messagingInst.getToken({
    //         serviceWorkerRegistration: serviceWorkerRegistration,
    //       });
    //       // navigator.serviceWorker.addEventListener('message', (event) => {
    //       //   console.log('on message from background', event.data);
    //       //   let payload = event.data;
    //       //   if (payload && payload.firebaseMessagingData) {
    //       //     payload = payload.firebaseMessagingData.data;
    //       //   }
    //       //   store.dispatch(appNotificationReceived(payload));
    //       // });
    //     });
    //   }
    // }
  } else {
    console.log("Firebase messaging already initialized");
  }

  return messagingInst;
}

export function messaging() {
  // console.log('fcmUnsupported', fcmUnsupported);
  // console.log('firebaseConfig', firebaseConfig);
  // if (!fcmUnsupported && firebaseConfig) {
  //   const messagingInst = firebase.messaging();
  //   return messagingInst;
  // }
  // return null;
  return messagingInst;
}
